import { Col, Progress, Row } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import LoyalityLevelCard from "src/components/LoyalityLevelCard";
import { CardC } from "src/shared/components";
import useAuth from "src/shared/hooks/useAuth";
import useDomain from "src/shared/hooks/useDomain";
import useGeneral from "src/shared/hooks/useGeneral";
import useRequest from "src/shared/hooks/useRequest";
import RoleEnum from "src/shared/ts/enum/role.enum";
import useSWR from "swr";

const Panel = () => {
  const { hasRole } = useAuth();
  const { push } = useHistory();
  const { t } = useTranslation();

  const domain = useDomain();

  const { onCreate } = useRequest();

  const isEndUser = hasRole(RoleEnum.end_user);

  useEffect(() => {
    push(`/panel/buyProduct`);
  }, []);

  return <div></div>;
};

export default Panel;
